import {
	BrowserWindow,
	BrowserWindowSymbol,
	IAppWillLoadPageHandler,
	IPageDidMountHandler,
	IPageDidUnmountHandler,
	IPropsStore,
	IStructureAPI,
	LifeCycle,
	Props,
	StructureAPI,
} from '@wix/thunderbolt-symbols'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { PageProviderSymbol, IPageProvider } from 'feature-pages'

export const PageMountUnmountSubscriber = withDependencies(
	[Props, StructureAPI, PageProviderSymbol, BrowserWindowSymbol],
	(
		props: IPropsStore,
		structureApi: IStructureAPI,
		pageReflectorProvider: IPageProvider,
		window: BrowserWindow
	): IAppWillLoadPageHandler => ({
		appWillLoadPage: async ({ pageId, contextId }) => {
			const pageReflector = await pageReflectorProvider(contextId)
			const pageDidMountHandlers = pageReflector.getAllImplementersOf<IPageDidMountHandler>(
				LifeCycle.PageDidMountHandler
			)
			const pageDidUnmountHandlers = pageReflector
				.getAllImplementersOf<IPageDidUnmountHandler>(LifeCycle.PageDidUnmountHandler)
				.map((m) => m.pageDidUnmount)

			const wrapperId = structureApi.getPageWrapperComponentId(pageId, contextId)
			props.update({
				[wrapperId]: {
					pageDidMount: async (isMounted: boolean) => {
						if (isMounted) {
							const funcs = await Promise.all(
								pageDidMountHandlers.map((pageDidMountHandler) =>
									pageDidMountHandler.pageDidMount(pageId)
								)
							)

							const unsubscribeFuncs = funcs.filter((x) => x) as Array<
								Exclude<typeof funcs[number], void>
							>
							pageDidUnmountHandlers.push(...unsubscribeFuncs)
						} else if (window) {
							// Make sure all the descendants are unmounted (window is always defined on unmount flow)
							window.requestAnimationFrame(async () => {
								await Promise.all(pageDidUnmountHandlers.map((pageDidUnmount) => pageDidUnmount()))
							})
						}
					},
				},
			})
		},
	})
)
